import { useEffect, useState } from "react";

const emptyArray: Array<string> = [];

export const useNewIds = ({
  ids,
  enabled = true,
}: {
  enabled?: boolean;
  ids?: Array<string>;
}) => {
  const [previousIds, setPreviousIds] = useState<Array<string>>([]);
  const [newItemIds, setNewItemIds] = useState<Array<string>>([]);

  useEffect(() => {
    if (ids == null || !enabled || ids.length === 0) {
      setNewItemIds(emptyArray);
      setPreviousIds(emptyArray);
      return;
    }
    if (newItemIds.length === 0) {
      setNewItemIds(ids);
      setPreviousIds(ids);
      return;
    }
    if (!newItemIds.every((id) => ids.includes(id))) {
      setNewItemIds(ids);
      setPreviousIds(newItemIds);
    }
  }, [ids, newItemIds, enabled]);

  return {
    newIds: newItemIds.filter((id) => !previousIds.includes(id)),
  };
};
